import { ReportProfileAlertResourceBaseModel } from '../../profile/report-profile-alert-resource-base-model';

export class ExchangeReportProfileAlertForwardMailboxesModel extends ReportProfileAlertResourceBaseModel {
  forwardMailboxes: string[];
}
